import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import {
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";

import {
  PublicFeature,
  TESTED_FEATURES_DESCRIPTION,
} from "api/public/project/product/product.types";

import ProductContentSection from "./ProductContentSection";

interface TestedFeaturesReadOnlyListProps {
  features: PublicFeature[];
}

const TestedFeaturesReadOnlyList = ({
  features,
}: TestedFeaturesReadOnlyListProps) => {
  return (
    <ProductContentSection title="TESTED FEATURES">
      <Box>
        <Typography variant="body2">{TESTED_FEATURES_DESCRIPTION}</Typography>
        <List dense>
          {features.map((feature) => (
            <ListItem key={feature.id} disableGutters>
              <ListItemIcon sx={{ minWidth: 36 }}>
                <CheckCircleIcon color="success" />
              </ListItemIcon>
              <ListItemText primary={feature.feature_name} />
            </ListItem>
          ))}
        </List>
      </Box>
    </ProductContentSection>
  );
};

export default TestedFeaturesReadOnlyList;
